import React from 'react'
import { Box,Collapsible, Grommet,ResponsiveContext} from 'grommet'
import Dashboard from './pages/dashboard'
import LoginForm from './pages/login'
import Quote from './pages/admin/quote'
import LabList from './pages/admin/labs/all'
import EditLab from './pages/admin/labs/edit'
import OrgList from './pages/admin/organisations/all'
import EditOrg from './pages/admin/organisations/edit'
import AllUsers from './pages/users/all'
import CreateUser from './pages/admin/users/create'
import EditUser from './pages/users/edit'
import LabCreateUser from './pages/users/create'
import AllCommodities from './pages/admin/commodities/all'
import CreateCommodity from './pages/admin/commodities/create'
import EditCommodity from './pages/admin/commodities/edit'
import AllCustomers from './pages/admin/customers/all'
import CreateCustomer from './pages/customers/create'
import EditCustomer from './pages/admin/customers/edit'
import LabCustomers from './pages/customers/all'
import LabEditCustomer from './pages/customers/edit'
import CreateQuote from './pages/quotes/create'
import QuoteCard from './pages/quotes/success'
import QuoteFail from './pages/quotes/fail'
import CreateLab from './pages/admin/labs/create'
import CreateOrg from './pages/admin/organisations/create'
import NavigationBar from './components/navigationBar'
import SiteFooter from './components/footer'
import SideBar from './components/sideBar'
import {BrowserRouter as Router,Switch,Route,Redirect} from "react-router-dom";
import CreateShipment from './pages/shipments/create'
import ViewShipment from './pages/shipments/view'
import {theme} from './components/theme.js'
import ShipmentSuccess from './pages/shipments/success'
import ShipmentFail from './pages/shipments/fail'
import Amplify from 'aws-amplify';
import awsconfig from './aws-exports';
import AdminAllShipments from './pages/admin/shipments/all'
import AdminAllInvoices from './pages/admin/billing/all'
import AllShipments from './pages/shipments/all'
import ShipmentDangerousGoods from './pages/shipments/dangerousGoods'
import CreateCollection from './pages/collections/create'
import CollectionFail from './pages/collections/fail'
import CollectionSuccess from './pages/collections/success'
import CreateAddress from './pages/addresses/create'
import AddressBook from './pages/addresses/all'
import AdminAddressBook from './pages/admin/addresses/all'
import AdminEditAddress from './pages/admin/addresses/edit'
import EditAddress from './pages/addresses/edit'
import ProtectedRoute from './components/protectedRoute'
import AllReports from './pages/admin/reports/all'
import BillingViewShipment from './pages/admin/shipments/billing'
import { API,Auth } from 'aws-amplify';
import './fonts.css';


Amplify.configure(awsconfig)
Amplify.configure({
  API: {
      endpoints: [
          {
              name: "LabShip",
              endpoint: process.env.REACT_APP_API_URL,

          }
      ]
  }
});
  

class App extends React.Component {
  state = {
    isUserAuthenticated: sessionStorage.getItem('isUserAuthenticated'),
    themeMode: false,
    showSidebar: false,
    whichTheme: 'light',
  }


  componentDidMount(){
    if (sessionStorage.getItem('isUserAuthenticated') === 'false'){
      this.setState({isUserAuthenticated: false})
    } else if (sessionStorage.getItem('isUserAuthenticated') === null){
      this.setState({isUserAuthenticated: false})
    } else {
      this.setState({isUserAuthenticated: true})
    }
  }

  getOrgLogo = (id) => {
    Auth.currentSession().then(session => {
      API
      .get("LabShip", `/organisations/${id}`,{headers: { 
          Authorization: session.idToken.jwtToken,
        }})
      .then(
        (result) => {
          this.setState({org: result})
        },
        (error) => {
          console.log(error)
        }
      )
    })
  }
  
  handleThemeMode = (mode) => {
      this.setState({themeMode: mode.target.value})
      this.toggleTheme(mode.target.value)
  }
  setSideBarOpenClose = (mode) => {
    this.setState({showSidebar: !this.state.showSidebar})
  }
  toggleTheme = (mode) => {
    if (mode){
      this.setState({whichTheme: 'light'})
    } else {
      this.setState({whichTheme: 'dark'})
    }
  }
  handleIsUserAuthenticated = (auth) => {
    if(auth){
      this.setState({isUserAuthenticated: true})
    } else {
      this.setState({isUserAuthenticated: false})
    }
  }

  setUserRole = (role) => {
    this.setState({userRole: role})
  }


  setDisplayQuote = (role) => {
    this.setState({displayQuote: role})
  }
  
  render(){
    const {isUserAuthenticated, showSidebar, userRole, displayQuote} = this.state;
    return (
      <Router>
        <Grommet full theme={theme}>
          <ResponsiveContext.Consumer>
          {size => (
            <Box style={{height: "max-height", minHeight:'100%'}}>
              <Box style={{position: "sticky", top:0, zIndex: 2}}><NavigationBar size={size} isUserAuthenticated={isUserAuthenticated} toggleSidebar={this.setSideBarOpenClose} org={this.state.org}/></Box>
              <Box direction='row-reverse' flex overflow={{ horizontal: 'hidden' }}>
                <Box flex background='light-1'>
                  <Switch>
                    <Route path="/login"><LoginForm handleIsUserAuthenticated={this.handleIsUserAuthenticated} setUserRole={this.setUserRole} setDisplayQuote={this.setDisplayQuote} size={size} /></Route>
                    <ProtectedRoute path='/admin/dashboard' component={Dashboard} isUserAuthenticated={isUserAuthenticated}setUserRole={this.setUserRole} setDisplayQuote={this.setDisplayQuote} getOrgLogo={this.getOrgLogo} size={size}/>
                    <ProtectedRoute path='/admin/users/all' component={AllUsers} isUserAuthenticated={isUserAuthenticated}setUserRole={this.setUserRole} setDisplayQuote={this.setDisplayQuote} getOrgLogo={this.getOrgLogo} size={size}/>
                    <ProtectedRoute path='/admin/users/new' component={CreateUser} isUserAuthenticated={isUserAuthenticated}setUserRole={this.setUserRole} setDisplayQuote={this.setDisplayQuote}getOrgLogo={this.getOrgLogo} size={size}/>
                    <ProtectedRoute path='/admin/users/edit' component={EditUser} isUserAuthenticated={isUserAuthenticated}setUserRole={this.setUserRole} setDisplayQuote={this.setDisplayQuote}getOrgLogo={this.getOrgLogo} size={size}/>
                    <ProtectedRoute path='/admin/billing/all' component={AdminAllInvoices} isUserAuthenticated={isUserAuthenticated}setUserRole={this.setUserRole} setDisplayQuote={this.setDisplayQuote}getOrgLogo={this.getOrgLogo} size={size}/>
                    <ProtectedRoute path='/admin/shipments/all' component={AdminAllShipments} isUserAuthenticated={isUserAuthenticated}setUserRole={this.setUserRole} setDisplayQuote={this.setDisplayQuote}getOrgLogo={this.getOrgLogo} size={size}/>
                    <ProtectedRoute path='/admin/quote' component={Quote} isUserAuthenticated={isUserAuthenticated} setUserRole={this.setUserRole} setDisplayQuote={this.setDisplayQuote}getOrgLogo={this.getOrgLogo} size={size}/>
                    <ProtectedRoute path='/admin/labs/all' component={LabList} isUserAuthenticated={isUserAuthenticated} setUserRole={this.setUserRole}setDisplayQuote={this.setDisplayQuote}getOrgLogo={this.getOrgLogo} size={size}/>
                    <ProtectedRoute path={`/admin/labs/edit/:lab_id`} component={EditLab} isUserAuthenticated={isUserAuthenticated}setUserRole={this.setUserRole} setDisplayQuote={this.setDisplayQuote} getOrgLogo={this.getOrgLogo} size={size}/>
                    <ProtectedRoute path='/admin/organisations/all' component={OrgList} isUserAuthenticated={isUserAuthenticated} setUserRole={this.setUserRole} setDisplayQuote={this.setDisplayQuote}getOrgLogo={this.getOrgLogo} size={size}/>
                    <ProtectedRoute path='/admin/organisations/new' component={CreateOrg} isUserAuthenticated={isUserAuthenticated}setUserRole={this.setUserRole} setDisplayQuote={this.setDisplayQuote}getOrgLogo={this.getOrgLogo} size={size}/>
                    <ProtectedRoute path='/admin/organisations/edit/:org_id' component={EditOrg} isUserAuthenticated={isUserAuthenticated}setUserRole={this.setUserRole}setDisplayQuote={this.setDisplayQuote}getOrgLogo={this.getOrgLogo} size={size}/>
                    <ProtectedRoute path='/admin/customers/all' component={AllCustomers} isUserAuthenticated={isUserAuthenticated}setUserRole={this.setUserRole}setDisplayQuote={this.setDisplayQuote}getOrgLogo={this.getOrgLogo} size={size}/>
                    <ProtectedRoute path='/admin/customers/new' component={CreateCustomer} isUserAuthenticated={isUserAuthenticated}setUserRole={this.setUserRole}setDisplayQuote={this.setDisplayQuote} getOrgLogo={this.getOrgLogo} size={size}/>
                    <ProtectedRoute path='/admin/customers/edit/:customer_id' component={EditCustomer} isUserAuthenticated={isUserAuthenticated}setUserRole={this.setUserRole} setDisplayQuote={this.setDisplayQuote}getOrgLogo={this.getOrgLogo} size={size}/>
                    <ProtectedRoute path='/admin/commodities/all' component={AllCommodities} isUserAuthenticated={isUserAuthenticated}setUserRole={this.setUserRole} setDisplayQuote={this.setDisplayQuote} getOrgLogo={this.getOrgLogo} size={size}/>
                    <ProtectedRoute path='/admin/commodities/new' component={CreateCommodity} isUserAuthenticated={isUserAuthenticated}setUserRole={this.setUserRole} setDisplayQuote={this.setDisplayQuote}getOrgLogo={this.getOrgLogo} size={size}/>
                    <ProtectedRoute path='/admin/commodities/edit/:commodity_id' component={EditCommodity} isUserAuthenticated={isUserAuthenticated}setUserRole={this.setUserRole} setDisplayQuote={this.setDisplayQuote}getOrgLogo={this.getOrgLogo} size={size}/>
                    <ProtectedRoute path='/admin/labs/new' component={CreateLab} isUserAuthenticated={isUserAuthenticated}setUserRole={this.setUserRole} setDisplayQuote={this.setDisplayQuote}getOrgLogo={this.getOrgLogo} size={size}/>
                    <ProtectedRoute path='/admin/reports/all' component={AllReports} isUserAuthenticated={isUserAuthenticated} setUserRole={this.setUserRole}setDisplayQuote={this.setDisplayQuote}getOrgLogo={this.getOrgLogo} size={size}/>
                    <ProtectedRoute path='/admin/addresses/all' component={AdminAddressBook} isUserAuthenticated={isUserAuthenticated} setUserRole={this.setUserRole}setDisplayQuote={this.setDisplayQuote}getOrgLogo={this.getOrgLogo} size={size}/>
                    <ProtectedRoute path={`/admin/addresses/edit/:address_id`} component={AdminEditAddress} isUserAuthenticated={isUserAuthenticated}setUserRole={this.setUserRole} setDisplayQuote={this.setDisplayQuote} getOrgLogo={this.getOrgLogo} size={size}/>
                    <ProtectedRoute path={'/admin/billing/shipment/:shipment_id'} component={BillingViewShipment} isUserAuthenticated={isUserAuthenticated} setUserRole={this.setUserRole}setDisplayQuote={this.setDisplayQuote}getOrgLogo={this.getOrgLogo} size={size}/>
                    <ProtectedRoute path='/addresses/create' component={CreateAddress} isUserAuthenticated={isUserAuthenticated}setUserRole={this.setUserRole} setDisplayQuote={this.setDisplayQuote}getOrgLogo={this.getOrgLogo} size={size}/>
                    <ProtectedRoute path='/addresses/all' component={AddressBook} isUserAuthenticated={isUserAuthenticated} setUserRole={this.setUserRole}setDisplayQuote={this.setDisplayQuote}getOrgLogo={this.getOrgLogo} size={size}/>
                    <ProtectedRoute path={`/addresses/edit/:address_id`} component={EditAddress} isUserAuthenticated={isUserAuthenticated}setUserRole={this.setUserRole} setDisplayQuote={this.setDisplayQuote} getOrgLogo={this.getOrgLogo} size={size}/>
                    <ProtectedRoute path='/dashboard' component={Dashboard} isUserAuthenticated={isUserAuthenticated}setUserRole={this.setUserRole} setDisplayQuote={this.setDisplayQuote} getOrgLogo={this.getOrgLogo} size={size} />
                    <ProtectedRoute path='/shipment/new' component={CreateShipment} isUserAuthenticated={isUserAuthenticated}setUserRole={this.setUserRole} userRole={userRole}setDisplayQuote={this.setDisplayQuote}getOrgLogo={this.getOrgLogo} size={size}/>
                    <ProtectedRoute path='/shipments/all' component={AllShipments} isUserAuthenticated={isUserAuthenticated}setUserRole={this.setUserRole} setDisplayQuote={this.setDisplayQuote}getOrgLogo={this.getOrgLogo} size={size}/>
                    <ProtectedRoute path='/shipment/success' component={ShipmentSuccess} isUserAuthenticated={isUserAuthenticated}setUserRole={this.setUserRole} setDisplayQuote={this.setDisplayQuote}getOrgLogo={this.getOrgLogo} size={size}/>
                    <ProtectedRoute path='/shipment/dangerous-goods' component={ShipmentDangerousGoods} isUserAuthenticated={isUserAuthenticated}setUserRole={this.setUserRole} setDisplayQuote={this.setDisplayQuote}getOrgLogo={this.getOrgLogo} size={size}/>
                    <ProtectedRoute path='/shipment/fail' component={ShipmentFail} isUserAuthenticated={isUserAuthenticated} setUserRole={this.setUserRole}setDisplayQuote={this.setDisplayQuote}getOrgLogo={this.getOrgLogo} size={size}/>
                    <ProtectedRoute path={'/shipment/:shipment_id'} component={ViewShipment} isUserAuthenticated={isUserAuthenticated} setUserRole={this.setUserRole}setDisplayQuote={this.setDisplayQuote}getOrgLogo={this.getOrgLogo} size={size}/>
                    <ProtectedRoute path='/quote/new' component={CreateQuote} isUserAuthenticated={isUserAuthenticated} setUserRole={this.setUserRole} setDisplayQuote={this.setDisplayQuote}getOrgLogo={this.getOrgLogo} size={size}/>
                    <ProtectedRoute path='/quote/success' component={QuoteCard} isUserAuthenticated={isUserAuthenticated} setUserRole={this.setUserRole} setDisplayQuote={this.setDisplayQuote}getOrgLogo={this.getOrgLogo} size={size}/>
                    <ProtectedRoute path='/quote/fail' component={QuoteFail} isUserAuthenticated={isUserAuthenticated} setUserRole={this.setUserRole} setDisplayQuote={this.setDisplayQuote}getOrgLogo={this.getOrgLogo} size={size}/>
                    <ProtectedRoute path='/collection/new' component={CreateCollection} isUserAuthenticated={isUserAuthenticated} setUserRole={this.setUserRole} setDisplayQuote={this.setDisplayQuote}getOrgLogo={this.getOrgLogo} size={size}/>
                    <ProtectedRoute path='/collection/success' component={CollectionSuccess} isUserAuthenticated={isUserAuthenticated} setUserRole={this.setUserRole} setDisplayQuote={this.setDisplayQuote}getOrgLogo={this.getOrgLogo} size={size}/>
                    <ProtectedRoute path='/collection/fail' component={CollectionFail} isUserAuthenticated={isUserAuthenticated} setUserRole={this.setUserRole} setDisplayQuote={this.setDisplayQuote}getOrgLogo={this.getOrgLogo} size={size}/>
                    <ProtectedRoute path='/users/all' component={AllUsers} isUserAuthenticated={isUserAuthenticated}setUserRole={this.setUserRole} setDisplayQuote={this.setDisplayQuote} getOrgLogo={this.getOrgLogo} size={size}/>
                    <ProtectedRoute path='/users/new' component={LabCreateUser} isUserAuthenticated={isUserAuthenticated}setUserRole={this.setUserRole}setDisplayQuote={this.setDisplayQuote} getOrgLogo={this.getOrgLogo} size={size}/>
                    <ProtectedRoute path='/users/edit' component={EditUser} isUserAuthenticated={isUserAuthenticated}setUserRole={this.setUserRole}setDisplayQuote={this.setDisplayQuote} getOrgLogo={this.getOrgLogo} size={size}/>
                    <ProtectedRoute path='/customers/all' component={LabCustomers} isUserAuthenticated={isUserAuthenticated}setUserRole={this.setUserRole} setDisplayQuote={this.setDisplayQuote}getOrgLogo={this.getOrgLogo} size={size}/>
                    <ProtectedRoute path='/customers/new' component={CreateCustomer} isUserAuthenticated={isUserAuthenticated}setUserRole={this.setUserRole} setDisplayQuote={this.setDisplayQuote}getOrgLogo={this.getOrgLogo} size={size}/>
                    <ProtectedRoute path='/customers/edit/:customer_id' component={LabEditCustomer} isUserAuthenticated={isUserAuthenticated}setUserRole={this.setUserRole}setDisplayQuote={this.setDisplayQuote}getOrgLogo={this.getOrgLogo} size={size}/>
                    <Route exact path="/"
                      render={() => {
                        return (
                          isUserAuthenticated ?
                          <Redirect to="/shipment/new"/> :
                          <Redirect to="/login"/>
                      )
                      }}
                  />
                  <Redirect from="*" to="/" />
                  </Switch>
                 
                </Box>
                  <Collapsible style={{position: "sticky", top:0, zIndex: 1}}  direction="horizontal" open={showSidebar}>
                    <Box style={{position: "sticky", top:0, zIndex: 1}} flex width='small' background='light-2'elevation='large'><SideBar toggleSidebar={this.setSideBarOpenClose} displayQuote={displayQuote} userRole={userRole}/></Box>
                  </Collapsible>
               
              </Box>   
              <SiteFooter size={size} />           
            </Box>  
          )}
        </ResponsiveContext.Consumer>
        </Grommet>
    </Router>
    )
  }
 
}

export default App
